import React, {useEffect, useRef, useState} from 'react'
import {Button, Col, Row, Typography} from "antd";
import {FilterFilled, VerticalAlignBottomOutlined, VerticalAlignTopOutlined} from "@ant-design/icons";

const {Title, Text} = Typography

export default (props) => {
    const MAX_HEIGHT = 1000
    const NORM_HEIGHT = 47
    const ref = useRef(null)
    const [isViewMore, setIsViewMore] = useState(false)
    const [maxHeight, setMaxHeight] = useState(NORM_HEIGHT)

    useEffect(() => {
        function updateByHeight() {
            if (ref) {
                const {offsetHeight, scrollHeight, clientHeight} = ref.current
                if (scrollHeight > offsetHeight + 10) {
                    if (!isViewMore)
                        setIsViewMore(true)
                } else {
                    if (isViewMore)
                        setIsViewMore(false)
                }
            }
        }

        function handleResize() {
            updateByHeight()
        }

        updateByHeight()

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [ref])

    return (
        <div style={{display: 'flex', flexDirection: 'row'}} data-tut="reactour__filters">
            <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}} ref={ref}
                 style={{maxHeight: maxHeight, overflowY: 'hidden'}}>
                <Col>
                    <Title level={4} style={{marginBottom: 0, paddingBottom: '14px'}}>
                        <FilterFilled/> Filter
                    </Title>
                </Col>
                {props.children}
            </Row>
            {isViewMore && (
                <Button style={{marginRight: 'auto', marginLeft: 12, paddingRight: 12}} type="text"
                        icon={maxHeight === NORM_HEIGHT ? <VerticalAlignBottomOutlined/> : <VerticalAlignTopOutlined/>}
                        onClick={() => {
                            if (maxHeight === MAX_HEIGHT) {
                                setMaxHeight(NORM_HEIGHT)
                            } else {
                                setMaxHeight(MAX_HEIGHT)
                            }
                        }}/>
            )}
        </div>
    )
}